import { useEmpty } from "@/utils";

type Formats = "ISO" | "LATAM" | "US" | "LATAMTIME" | "TIME";

/**
 * @name useDate
 * @param Dates {string} Example: '2020-01-01' || '01/01/2020' || '01/01/2020 12:00:00'
 * @param Format {string} Example: 'ISO' || 'LATAM' || 'US'
 * @returns {string} Example: '01/01/2020' || '01/01/2020T12:00:00Z'
 */
function useDate(Dates: string, Format?: Formats, Validate?: boolean): string {
  if (Dates === undefined || Dates === null || Dates?.length <= 0) {
    return null;
  }

  let SplittedDate =
    Dates?.indexOf("/") !== -1 ? Dates?.split("/") : Dates?.split("-");
  let StringDate =
    Dates?.indexOf("/") !== -1
      ? `${SplittedDate?.[1]}/${SplittedDate?.[0]}/${SplittedDate?.[2]}`
      : Dates;
  switch (Format) {
    case "ISO":
      var DateObj = new Date(StringDate);
      const ISOString = DateObj?.toISOString(); // Example: '2020-01-01T00:00:00.000Z'
      return ISOString;
    case "LATAM":
      var DateObj = new Date(StringDate);
      const LATAMString = DateObj?.toISOString();
      const LATAMDate = LATAMString?.split("T")?.[0];
      const LATAMTimes = LATAMDate?.split("-");
      const LATAMFormat = `${LATAMTimes?.[2]}/${LATAMTimes?.[1]}/${LATAMTimes?.[0]}`;
      return LATAMFormat;
    case "US":
      var DateObj = new Date(StringDate);
      const USString = DateObj?.toISOString();
      const USDate = USString?.split("T")?.[0];
      return USDate;
    case "LATAMTIME":
      var DateObj = new Date(StringDate);
      const LATAMTIMEString = DateObj?.toISOString();
      const LATAMTIMEDate = LATAMTIMEString?.split("T")?.[0];
      const LATAMTIMETimes = LATAMTIMEDate?.split("-");
      const LATAMHours = DateObj?.getHours();
      const LATAMMinutes = DateObj?.getMinutes();
      const LATAMTIMEFormat = `${LATAMTIMETimes?.[2]}/${LATAMTIMETimes?.[1]}/${LATAMTIMETimes?.[0]} ${LATAMHours}h${LATAMMinutes}`;
      return LATAMTIMEFormat;
    case "TIME":
      var DateObj = new Date(StringDate);
      const TIMEHours = DateObj?.getHours();
      const TIMEMinutes = DateObj?.getMinutes();
      const TIMEFormat = `${TIMEHours}h${TIMEMinutes}`;
      return TIMEFormat;
  }
}

export { useDate };
